import React from 'react';
import c from 'classnames';

import { SearchActiveFacetsProps } from '@uncinc/react-searchkit/dist/components/ActiveFacets';

import SearchActiveFacets from '../../Search/ActiveFacets';

const SearchTeamActiveFacets: React.FC<Pick<SearchActiveFacetsProps, 'className'>> = (props) => {
  const { className } = props;

  const classNames = c('SearchTeam__ActiveFacets', className);

  return (
    <SearchActiveFacets className={classNames} />
  );
};

export default SearchTeamActiveFacets;
